import React from 'react';

const Header = props => <tr>{props.children}</tr>;

export default Header;
